module.exports = __webpack_public_path__ + "static/media/img_overpaper3@2x.9d8a6b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_overpaper3@2x.png
// module id = 965
// module chunks = 0